import React, { useMemo } from 'react';
import Stack from '@gogame/ui/Stack';

import { SearchMulti, isSearchExp, SearchExp } from '../helpers';

import Metrics from './Metrics';
import SelectedMetrics from './SelectedMetrics';
const defaultGetOptionMetricValue = (opt) => {
  return opt?.name;
};

const defaultGetOptionLabel = ({ displayName, name }) => displayName || name;

const defaultGetOptionHint = ({ categoryId, hint, creatorName }) =>
  categoryId ? (categoryId === 2 ? `${creatorName} | ${hint}` : hint) : null;

const MetricsPicker = ({
  searchQuery,
  selected,
  metrics,
  onClearAll,
  setSelected,
  onEditMetric,
  onDeleteMetric,
  onCreateMetric,
  secondaryAction,
  groupAction,
  grouped,
  formatData,
  filterField = 'fullDisplayName',
  getOptionMetricValue = defaultGetOptionMetricValue,
  getOptionLabel = defaultGetOptionLabel,
  getOptionHint = defaultGetOptionHint,
  numberOfGroupMaxSelectedItems,
  selectedSecondaryActionHelpRenderer,
  isInitialExpanded,
}) => {
  const filteredMetrics = useMemo(() => {
    if (searchQuery) {
      const searchQueryString = searchQuery.toLowerCase();
      let search = new SearchMulti(searchQueryString);

      if (isSearchExp(searchQueryString)) {
        try {
          search = new SearchExp(searchQueryString);
        } catch (e) {}
      }
      return metrics.filter((metric) => {
        return search.match(metric[filterField].toLowerCase());
      });
    } else {
      return metrics;
    }
  }, [metrics, searchQuery]);

  return (
    <Stack direction={'row'} style={{ flex: 1, minHeight: 528 }}>
      <Metrics
        grouped={grouped}
        filtered={!!searchQuery}
        metrics={filteredMetrics}
        selected={selected}
        onUpdateMetric={onEditMetric}
        onDeleteMetric={onDeleteMetric}
        onSelect={setSelected}
        onAddMetric={onCreateMetric}
        secondaryAction={secondaryAction}
        groupAction={groupAction}
        formatData={formatData}
        getOptionMetricValue={getOptionMetricValue}
        getOptionHint={getOptionHint}
        getOptionLabel={getOptionLabel}
        numberOfGroupMaxSelectedItems={numberOfGroupMaxSelectedItems}
        isInitialExpanded={isInitialExpanded}
      />
      <SelectedMetrics
        metrics={metrics}
        selected={selected}
        onClearAll={onClearAll}
        onChange={setSelected}
        onUpdateMetric={onEditMetric}
        getOptionLabel={getOptionLabel}
        getOptionMetricValue={getOptionMetricValue}
        selectedSecondaryActionHelpRenderer={
          selectedSecondaryActionHelpRenderer
        }
      />
    </Stack>
  );
};

export default MetricsPicker;
